export default "__VITE_ASSET__DB37QsAa__"